import type { ModuleNavigation } from '../../layouts/ModuleSidebar';

export const courtNavigation: ModuleNavigation = [
  {
    title: 'Overview',
    items: [
      { path: '/court/dashboard', label: 'Dashboard' },
    ],
  },
  {
    title: 'Entities',
    items: [
      { path: '/court/litigation', label: 'التقاضي — Litigation' },
    ],
  },
];
